import React, { useCallback } from 'react';
import { OnUpdateSavedReport } from 'app/area/shared/saved-reports/types';
import { useInvalidSection } from '../metroline/invalid-section';
import { companyReportConfiguration, getCompanyReportRoute } from '../metroline/company-report-configuration';
import { CompanyReportItem, SavedReportCompanyReport } from '../types-store';
import { CompanyReportFormProps } from '../types';
import { CompanyReportFormRenderer } from './company-report-form-renderer';
import { ApplicationState } from 'app/types-store';

export const CompanyReportFormSections: React.FC<CompanyReportFormProps> = ({
  formState, mainLanguage, options, section, locale, translation, companyReportAccess, translationAdminAccess, showTranslations,
  shouldPrompt, saveCompanyReport, deleteCompanyReport, updateValidation, resetValidation, displayError,
  addFilters, updateFilter, deleteFilter, deleteAllFilters, updateFiltersValidation,
  selectCurrentSavedReports, updateCurrentSavedReports, updateCurrentValidation, loadSavedReportEvaluation,
  addSavedReports, updateSavedReport, deleteSavedReport, deleteAllSavedReports, updateSavedReportValidation, switchDisplayDisabled,
  updateItem, changeLanguage, copyLanguageToAll, loadOptions, updateTextDescription,
  updateTextItem, updateTextItemDescription, removeText, addText, resetTextValidation, resetTextsValidation, removeAllTexts,
  updateMetadataItem, removeMetadata, addMetadata, resetMetadataValidation, removeAllMetadata, switchTranslationsToggle
}) => {

  const scrollViewUrl = getCompanyReportRoute(formState.companyReportItem?.id);

  const configuration = companyReportConfiguration(
    formState.companyReportItem?.id,
    formState.validation,
    formState.savedReportsValidation,
    formState.filterValidation,
    formState.textsValidation,
    formState.metadataValidation
  );

  const [invalidSection, updateInvalidSection] = useInvalidSection(
    configuration, formState.validation, formState.savedReportsValidation,
    formState.filterValidation, formState.textsValidation, formState.metadataValidation
  );

  const onSaveCompanyReport = (item: CompanyReportItem) => {
    updateInvalidSection(undefined);
    saveCompanyReport(item);
  };

  const loadEvaluation = useCallback((savedReportId: number, onUpdateSavedReport: OnUpdateSavedReport<SavedReportCompanyReport>) => {
    const getState = (state: ApplicationState) => state?.companyReportAdministration?.form;
    const onSavedReportError = () => {
      displayError(translation.fields_are_filled_out_incorrectly);
    };
    loadSavedReportEvaluation(formState?.typeId, savedReportId, onUpdateSavedReport, onSavedReportError, getState);
  }, [formState?.typeId]
  );

  return <CompanyReportFormRenderer
    formState={formState}
    mainLanguage={mainLanguage}
    shouldPrompt={shouldPrompt}
    saveCompanyReport={onSaveCompanyReport}
    deleteCompanyReport={deleteCompanyReport}
    updateItem={updateItem}
    changeLanguage={changeLanguage}
    copyLanguageToAll={copyLanguageToAll}
    options={options}
    loadOptions={loadOptions}
    updateValidation={updateValidation}
    resetValidation={resetValidation}
    displayError={displayError}
    locale={locale}
    validation={formState.validation}
    translation={translation}
    label={translation.manage_company_reports_title}
    section={section}
    initialSection={section}
    configuration={configuration}
    scrollViewUrl={scrollViewUrl}
    invalidSection={invalidSection}
    updateTextDescription={updateTextDescription}
    removeText={removeText}
    addText={addText}
    removeAllTexts={removeAllTexts}

    updateTextItem={updateTextItem}
    updateTextItemDescription={updateTextItemDescription}
    resetTextValidation={resetTextValidation}
    resetTextsValidation={resetTextsValidation}
    textsValidation={formState.textsValidation}

    addMetadata={addMetadata}
    removeMetadata={removeMetadata}
    removeAllMetadata={removeAllMetadata}
    updateMetadataItem={updateMetadataItem}
    resetMetadataValidation={resetMetadataValidation}
    metadataValidation={formState.metadataValidation}

    selectCurrentSavedReports={selectCurrentSavedReports}
    updateCurrentSavedReports={updateCurrentSavedReports}
    updateCurrentValidation={updateCurrentValidation}
    loadEvaluation={loadEvaluation}
    addSavedReports={addSavedReports}
    updateSavedReport={updateSavedReport}
    deleteSavedReport={deleteSavedReport}
    deleteAllSavedReports={deleteAllSavedReports}
    switchDisplayDisabled={switchDisplayDisabled}
    savedReportsValidation={formState.savedReportsValidation}
    updateSavedReportValidation={updateSavedReportValidation}

    addFilters={addFilters}
    updateFilter={updateFilter}
    deleteFilter={deleteFilter}
    deleteAllFilters={deleteAllFilters}
    updateFiltersValidation={updateFiltersValidation}

    companyReportAccess={companyReportAccess}
    translationAdminAccess={translationAdminAccess}

    showTranslations={showTranslations}
    switchTranslationsToggle={switchTranslationsToggle}
  />;
};
